export type DIE_RESULT =
    | 'STAR'
    | 'DOUBLE_STAR'
    | 'BOTTLE'
    | 'DOUBLE_BOTTLE'
    | 'BOTTLE_STAR'
    | 'BLAST'
    | 'BREAK_ARMOR'
    | 'DOUBLE_BREAK_ARMOR'
    | 'DAMAGE'
    | 'DOUBLE_DAMAGE'
    | 'MINUS_1'
    | 'MINUS_2'
    | 'MINUS_3'
    | 'BLANK';

export const DIE_RESULTS = {
    STAR: 'STAR',
    DOUBLE_STAR: 'DOUBLE_STAR',
    BOTTLE: 'BOTTLE',
    DOUBLE_BOTTLE: 'DOUBLE_BOTTLE',
    BOTTLE_STAR: 'BOTTLE_STAR',
    BLAST: 'BLAST',
    BREAK_ARMOR: 'BREAK_ARMOR',
    DOUBLE_BREAK_ARMOR: 'DOUBLE_BREAK_ARMOR',
    DAMAGE: 'DAMAGE',
    DOUBLE_DAMAGE: 'DOUBLE_DAMAGE',
    MINUS_1: 'MINUS_1',
    MINUS_2: 'MINUS_2',
    MINUS_3: 'MINUS_3',
    BLANK: 'BLANK'
};
